import { useCallback } from "react"
import { useDropzone } from "react-dropzone"
import {
  FolderArrowDownIcon,
  FolderPlusIcon,
} from "@heroicons/react/24/outline"
import clsx from "clsx"
import { last } from "lodash-es"
import Spinner from "./Spinner"

const GameUpload = ({
  onFileChange,
  isProcessing,
}: {
  onFileChange: (arg0: string) => void
  isProcessing: boolean
}) => {
  const onDrop = useCallback(
    (files: any) => {
      const file = files[0]

      if (!file) return

      if (
        file.type !== "application/x-chess-pgn" &&
        last(file.name.split(".")) !== "pgn"
      ) {
        return alert("That doesn’t look like a valid PGN file.")
      }

      const reader = new FileReader()

      reader.onload = (event) => {
        try {
          const result = event?.target?.result

          if (typeof result !== "string") return

          onFileChange(result)
        } catch (e) {
          console.log(e)
          alert("Games could not be processed.")
        }
      }

      reader.readAsText(file)
    },
    [onFileChange]
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    disabled: isProcessing,
  })

  return (
    <div
      {...getRootProps()}
      className={clsx(
        "mt-4 flex w-full flex-col items-center justify-center rounded-lg border border-dashed px-6 py-10",
        isDragActive
          ? "border-gray-900/50 bg-gray-100"
          : "border-gray-900/25 bg-transparent",
        {
          "cursor-pointer hover:border-gray-900/50 hover:bg-gray-100":
            !isProcessing,
        }
      )}
    >
      <input {...getInputProps()} />
      {isProcessing ? (
        <div className="flex h-12 items-center justify-center">
          <Spinner size="sm" className="text-gray-600" />
        </div>
      ) : isDragActive ? (
        <FolderArrowDownIcon className="mx-auto h-12 w-12" aria-hidden="true" />
      ) : (
        <FolderPlusIcon
          className="mx-auto h-12 w-12 text-gray-300"
          aria-hidden="true"
        />
      )}
      <p className="mt-4 text-center text-sm font-medium text-gray-600">
        Click to select a PGN file,
        <br /> or drag and drop
      </p>
    </div>
  )
}

export default GameUpload
